// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Menu_navbar__2HI3z","navbarBrand":"Menu_navbarBrand__29MTr","navLinkCont":"Menu_navLinkCont__28eLq","navLink":"Menu_navLink__1hs6y","active":"Menu_active__1d32I"};